// extracted by mini-css-extract-plugin
export default {"container":"cF-z","innerContainer":"dF-z","multipleLines":"eF-z","heading":"fF-z","content":"gF-z","linkColor":"hF-z"};